<template>
  <PageLayout>
    <div class="d-flex align-center justify-space-between">
      <h2 class="text-h3 font-weight-bold pb-4">
        Chytrá publika
      </h2>

      <v-btn small rounded text color="navy">
        <v-icon left>mdi-refresh</v-icon>
        Aktualizovat
      </v-btn>
    </div>

    <div class="mb-6 d-flex justify-space-between align-center">
      <v-btn
        medium
        outlined
        elevation="0"
        color="amber"
        class="c-btn"
        @click="onNewAudienceClick"
      >
        <v-icon left>mdi-plus</v-icon>
        Přidat chytré publikum
      </v-btn>
    </div>

    <v-card elevation="0">
      <v-data-table
        :items="smartAudiences"
        :headers="headers"
        :custom-sort="customSort"
        item-key="name"
        class="c-data-table c-data-table--alternate"
      >
        <template #item.smartAudienceDraftProducts="{ item }">
          <span> {{ getProductNames(item) }} </span>
        </template>

        <template #item.createdAt="{ item }">
          <div>
            <ui-datetime date :value="item.createdAt" />
          </div>
          <div class="body-1 grey--text">
            <ui-datetime time :value="item.createdAt" />
          </div>
        </template>
        <template #item.actions="{ item }">
          <ui-table-actions :actions="actions" @delete="onDelete(item)" />
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mt-5 px-2 py-10">
      <iframe
        src="https://player.vimeo.com/video/693599643?h=107ac11a6f"
        width="640"
        height="320"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    </v-card>
  </PageLayout>
</template>

<script>
import { call, get } from "vuex-pathify"
import SmartAudiencesAPI from "@/api/smartAudiences"

import PageLayout from "@/components/page/home/PageLayout.vue"
import Toastification from "../../components/ui/Toastification"
import { createCustomSort } from "../../helpers/table"
import { compareStrings } from "../../helpers/strings"

const headers = [
  { text: "Název", value: "name" },
  { text: "Produkty", value: "smartAudienceDraftProducts" },
  { text: "Velikost", value: "size" }, //TODO: Get possible audience reach
  { text: "Vytvořeno", value: "createdAt" },
  { text: "", value: "actions", sortable: false, align: "end" },
]

const parameters = {
  blogs: "Blog",
  magnets: "Magnety",
  magnetThankPages: "Děkovací stránky - magnety",
  sellPages: "Prodejní stránka",
  orderPages: "Objednávková stránka",
  orderThankPages: "Děkovací stránky - objednávky",
}

const actions = [
  {
    text: "Upravit",
    icon: "mdi-pencil-outline",
    disabled: true,
    tooltip: "Úprava okruhů uživatelů bude přístupná v příští verzi",
  },
  {
    text: "Smazat",
    icon: "mdi-delete-outline",
    iconClass: "red--text",
    textClass: "red--text",
    emit: "delete",
  },
]

function getProductNames(smartAudience) {
  return smartAudience.smartAudienceDraftProducts
    .map(smartAudience => smartAudience.name)
    .sort(compareStrings)
    .join(", ")
}

export default {
  name: "SmartAudiencesIndex",
  components: {
    PageLayout,
  },
  data() {
    return {
      headers,
      actions,
      parameters,
    }
  },
  computed: {
    ...get("smartAudiences", ["smartAudiences"]),
  },
  methods: {
    ...call("smartAudiences", [
      "clearSmartAudiencesModel",
      "getSmartAudienceDrafts",
      "deleteSmartAudienceDraft",
    ]),
    onNewAudienceClick() {
      this.clearSmartAudiencesModel()
      this.$router.push("/smart-audiences/new")
    },
    publishSmartAudienceDraft(draftId) {
      SmartAudiencesAPI.publishSmartAudienceDraft(draftId)
    },
    onDelete(item) {
      this.deleteSmartAudienceDraft(item.id)
    },
    customSort: createCustomSort({
      smartAudienceDraftProducts: {
        type: "string",
        transform: (_, smartAudience) => getProductNames(smartAudience),
      },
    }),
    getProductNames,
  },
  mounted() {
    if (this.$route.query.success !== undefined) {
      this.$toast.success({
        component: Toastification,
        props: {
          title: "Chytré publikum uloženo",
          text: "Vaše chytré publikum bylo úspěšně uloženo",
        },
      })
    }
    this.getSmartAudienceDrafts()
  },
}
</script>
